const {Component} = require("react");
const PropTypes = require("prop-types");
const Loader = require("app/components/mixins/Loader");
const assign = require("object-assign");
const Paginator = require("app/components/lists/Paginator");
const axios = require("axios");
const debounce = require("app/util/debounce");
const {animateBodyScrollToAnchorElement} = require("app/util/animateScroll");
const Link = require("app/components/mixins/Link");

class List extends Component {

	static get propTypes() {
		return {
			searchPlaceholder: PropTypes.string,
			noItemsText: PropTypes.string,
			items: PropTypes.array,
			activeGroup: PropTypes.string,
			scrollAnchorSelector: PropTypes.string,
			scrollOffset: PropTypes.number
		};
	}

	static get defaultProps() {
		return {
			searchPlaceholder: translate("Søg..."),
			noItemsText: translate("Intet fundet"),
			items: [],
			scrollOffset: 0
		};
	}

	constructor(props) {
		super(props);

		let activeGroup = 0;

		if (props.activeGroup) {
			if (typeof props.activeGroup === "number") {
				activeGroup = props.activeGroup;
			}
			else {
				for (let i = 0; i < props.items.length; i++) {
					if (props.items[i].guid === props.activeGroup) {
						activeGroup = i;
					}
				}
			}
		}

		this.state = {
			activeGroup: activeGroup,
			items: props.items.length > 0 ? props.items[activeGroup].items : [],
			pagination: props.items.length > 0 ? props.items[activeGroup].pagination : null,
			loading: false
		};
	}

	shoudLoadGroup(index) {
		//currently not needed?
		return (this.searchInput.value.length >= 0) ||
			!this.props.items[index] ||
			!this.props.items[index].items;
	}

	get currentPage() {
		return this.state.pagination && (this.state.pagination.pages > 0) ?
			this.state.pagination.page : null;
	}

	get currentGroup() {
		return this.props.items[this.state.activeGroup];
	}

	get className() {
		return "grouped-list dynamic-grouped-list";
	}

	setGroup(index) {
		this.setState(prevState => {
			let state = assign({}, prevState);
			state.activeGroup = index;
			state.pagination = this.props.items[index].pagination;
			state.items = this.props.items[index].items;

			return state;
		}, this.onUpdate);
	}

	loadGroup(index, page = 1) {
		this.setState({loading: true});

		return axios.get(this.endpoint(index, page, this.searchInput.value)).then(response => {
			this.setState(prevState => {
				let state = assign({}, prevState);

				state.loading = false;
				state.activeGroup = index;
				state.items = response.data.collection;
				state.pagination = response.data.pagination;

				return state;
			}, this.onUpdate);
		});
	}

	onUpdate() {
	}

	_groupClickListener = (i, item) => {

		return () => {
			//e.preventDefault();
			window.history.pushState('', '',url = item.link);
			
			if (this.state.activeGroup !== i) {
				if (this.shoudLoadGroup(i)) {
					this.loadGroup(i);
				}
				else {
					this.setGroup(i);
				}
			}
		};
	};

	_onPageChange = (page) => {
		this.changePage(page);
	};

	changePage(page){
		this.loadGroup(this.state.activeGroup, page).then(() => animateBodyScrollToAnchorElement(
			this.props.scrollAnchorSelector,
			this.props.scrollOffset
		));
	}

	_onSearchInput = debounce(500, () => {
		if (this.shoudLoadGroup(this.state.activeGroup)) {
			this.loadGroup(this.state.activeGroup, 1);
		}
		else {
			this.setGroup(this.state.activeGroup);
		}
	});

	getGroupLink(item) {
		return item.link || "#";
	}

	renderGroupTriggers() {
		return this.props.items.map((item, i) => {
			let className = i === this.state.activeGroup ? "active" : "";
			return (
				<Link key={i} className={className} href={this.getGroupLink(item)}
							onClick={this._groupClickListener(i, item)}>{item.title}</Link>
			);
		});
	}

	renderHeader() {
		return (
			<div className="header">
				<div className="search">
					<input type="text" defaultValue={this.props.search} placeholder={this.props.searchPlaceholder} ref={el => this.searchInput = el}
								 onInput={this._onSearchInput}/>
				</div>
				<div className="group-toggles">{this.renderGroupTriggers()}</div>
			</div>
		);
	}

	renderList() {
		// extend this...
	}

	renderItems() {
		if (this.state.items.length > 0) {
			return this.renderList();
		}

		return (
			<div className="no-items">{this.props.noItemsText}</div>
		);
	}

	renderPaginator() {
		if (!this.currentPage) {
			return;
		}

		const {page, pages} = this.state.pagination;

		return (
			<Paginator page={page} pages={pages} onChange={this._onPageChange}/>
		);
	}

	renderGroup() {
		return (
			<div className="group active">
				{this.renderItems()}
				{this.renderPaginator()}
			</div>
		);
	}

	render() {
		let className = this.className;

		if (this.state.loading) {
			className += " loading";
		}

		return (
			<div className={className}>
				{this.renderHeader()}
				<div className="body">
					<Loader active={this.state.loading}/>
					{this.renderGroup()}
				</div>
			</div>
		);
	}

}

module.exports = List;
